export const RECIPIENT_KEY_PREFIX = 'REK'; // recipient edit key

let nextKey = 0;
export function nextRecipientKey(): string {
    return RECIPIENT_KEY_PREFIX + ('000000' + (nextKey++).toString(16)).slice(-6);
}
